import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { store } from '../store/store';

// Single choke point: all haptics no-op when the signed-in user has
// hapticsEnabled === false. Logged-out/guest users and old-backend payloads
// (field absent) default to haptics ON.
const isHapticsEnabled = () =>
  store.getState().user.profile?.hapticsEnabled ?? true;

export const hapticsImpactLight = async () => {
  if (Capacitor.isNativePlatform() && isHapticsEnabled()) {
    await Haptics.impact({ style: ImpactStyle.Light });
  }
};

export const hapticsImpactMedium = async () => {
  if (Capacitor.isNativePlatform() && isHapticsEnabled()) {
    await Haptics.impact({ style: ImpactStyle.Medium });
  }
};

export const hapticsImpactLightNonBlocking = () => {
  // Fire haptics without awaiting to prevent blocking
  hapticsImpactLight().catch(() => {
    /* ignore haptics errors */
  });
};
